<div class="input-group">
  <input *ngIf="!withTime" type="date" class="form-control boder-black {{className}}">
  <input *ngIf="withTime" type="datetime-local" class="form-control boder-black {{className}}">
</div>